<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane label="第三方服务账户" name="first">
                <other-service-account></other-service-account>
            </el-tab-pane>
            <el-tab-pane label="第三方服务支出明细" name="second">
                <other-service-expenditure></other-service-expenditure>
            </el-tab-pane>
            <el-tab-pane label="第三方服务充值记录" name="three">
                <other-cloud-service-recharge></other-cloud-service-recharge>
            </el-tab-pane>
        </el-tabs>

    </el-card>
</template>
<script>

import OtherServiceAccount from '@/pages/vipCard/otherServiceManager/children/OtherServiceAccount'
import OtherServiceExpenditure from '@/pages/vipCard/otherServiceManager/children/OtherServiceExpenditure'
import OtherCloudServiceRecharge from '@/pages/vipCard/otherServiceManager/children/OtherCloudServiceRecharge'
export default {
  components: { OtherCloudServiceRecharge, OtherServiceExpenditure, OtherServiceAccount },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
